// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RB0Y","colBig":"styles_colBig__3bIpM","colSmall":"styles_colSmall__2jq2c"};